/* Brando grouped reviews — renders the product-page review list.
 * Initial data comes from the product's brando_reviews.summary metafield (embedded as JSON);
 * other pages and star filters come from the brando-reviews-display API.
 * Texts and visibility come from the section's theme-editor settings (data-* attributes). */
(function () {
  "use strict";

  var T = {
    reviews: function (n) { return n === 1 ? "1 anmeldelse" : Number(n).toLocaleString("nb-NO") + " anmeldelser"; },
    basedOn: function (n) { return "Basert på " + T.reviews(n); },
    verified: "Verifisert kjøper",
    colour: "Farge",
    reply: "Svar fra Brando",
    prev: "Forrige",
    next: "Neste",
    page: function (n) { return "Side " + n; },
    showAll: "Vis alle",
    filtered: function (star, n) { return T.reviews(n) + " med " + star + " stjerner"; },
    none: "Ingen anmeldelser ennå.",
    error: "Kunne ikke laste anmeldelsene. Prøv igjen.",
    stars: function (r) { return r + " av 5 stjerner"; },
  };

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function stars(rating, cls) {
    var wrap = el("span", "br-stars " + (cls || ""));
    wrap.setAttribute("role", "img");
    wrap.setAttribute("aria-label", T.stars(Number(rating).toFixed(1).replace(".", ",")));
    for (var i = 1; i <= 5; i++) {
      var fill = Math.max(0, Math.min(1, rating - (i - 1)));
      var s = el("span", "br-star");
      s.style.setProperty("--fill", Math.round(fill * 100) + "%");
      s.setAttribute("aria-hidden", "true");
      wrap.appendChild(s);
    }
    return wrap;
  }

  function formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString("nb-NO", { day: "numeric", month: "long", year: "numeric" });
    } catch (e) {
      return iso.slice(0, 10);
    }
  }

  function renderReview(r, opts) {
    var item = el("article", "br-review");
    item.setAttribute("data-review-id", r.id);

    var head = el("div", "br-review__head");
    head.appendChild(stars(r.rating, "br-stars--sm"));
    head.appendChild(el("time", "br-review__date", formatDate(r.createdAt))).setAttribute("datetime", r.createdAt);
    item.appendChild(head);

    var who = el("div", "br-review__who");
    who.appendChild(el("span", "br-review__author", r.author));
    if (r.verified && opts.showVerified) who.appendChild(el("span", "br-review__verified", T.verified));
    item.appendChild(who);

    var meta = el("div", "br-review__meta");
    if (r.variantLabel && opts.showColour) {
      var linked = r.productHandle && String(r.productId) !== String(opts.productId);
      var colour = el(linked ? "a" : "span", "br-chip br-review__colour", T.colour + ": " + r.variantLabel);
      if (linked) colour.href = "/products/" + encodeURIComponent(r.productHandle);
      meta.appendChild(colour);
    }
    if (opts.showFit) {
      (r.answers || []).forEach(function (a) {
        meta.appendChild(el("span", "br-chip br-review__answer", a.question + ": " + a.answer));
      });
    }
    if (meta.childNodes.length) item.appendChild(meta);

    if (r.title && r.body.indexOf(r.title.replace(/[\s–-]+$/, "")) !== 0) item.appendChild(el("h3", "br-review__title", r.title));
    if (r.body) {
      var body = el("div", "br-review__body");
      r.body.split(/\n{2,}/).forEach(function (para) {
        var p = el("p");
        para.split("\n").forEach(function (line, i) {
          if (i) p.appendChild(document.createElement("br"));
          p.appendChild(document.createTextNode(line));
        });
        body.appendChild(p);
      });
      item.appendChild(body);
    }

    if (r.pictures && r.pictures.length) {
      var pics = el("div", "br-review__pics");
      r.pictures.forEach(function (pic) {
        var a = el("a", "br-review__pic");
        a.href = pic.large;
        a.target = "_blank";
        a.rel = "noopener";
        var img = el("img");
        img.src = pic.small;
        img.loading = "lazy";
        img.alt = "";
        // Fixed size on the element: the theme's global img rule would otherwise stretch it full width.
        img.width = 88;
        img.height = 88;
        img.style.cssText = "width:88px;height:88px;max-width:88px;object-fit:cover;border-radius:8px;display:block";
        a.appendChild(img);
        pics.appendChild(a);
      });
      item.appendChild(pics);
    }

    if (r.replyHtml) {
      var reply = el("div", "br-review__reply");
      reply.appendChild(el("div", "br-review__reply-label", opts.replyLabel || T.reply));
      var content = el("div", "br-review__reply-body");
      // Sanitised server-side (sanitize-html allowlist: p, br, b, i, a[href], lists).
      content.innerHTML = r.replyHtml;
      reply.appendChild(content);
      item.appendChild(reply);
    }
    return item;
  }

  function renderFit(fit) {
    var box = el("div", "br-fit");
    box.appendChild(el("div", "br-fit__title", fit.question));
    fit.answers.forEach(function (a) {
      var pct = Math.round((a.count / fit.total) * 100);
      var row = el("div", "br-fit__row");
      row.appendChild(el("span", "br-fit__label", a.answer));
      var bar = el("span", "br-fit__bar");
      var fill = el("span", "br-fit__fill");
      fill.style.width = pct + "%";
      bar.appendChild(fill);
      row.appendChild(bar);
      row.appendChild(el("span", "br-fit__pct", pct + " %"));
      box.appendChild(row);
    });
    return box;
  }

  function renderSummary(data, opts, onFilter) {
    var box = el("div", "br-summary");
    var left = el("div", "br-summary__score");
    left.appendChild(el("div", "br-summary__avg", data.average.toFixed(1).replace(".", ",")));
    left.appendChild(stars(data.average, "br-stars--lg"));
    left.appendChild(el("div", "br-summary__count", T.basedOn(data.count)));
    if (opts.grouped && opts.groupNote) left.appendChild(el("div", "br-summary__note", opts.groupNote));
    box.appendChild(left);

    if (opts.showHistogram) {
      var hist = el("div", "br-histogram");
      for (var s = 5; s >= 1; s--) {
        var n = data.histogram[String(s)] || 0;
        var row = el("button", "br-histogram__row");
        row.type = "button";
        row.disabled = n === 0;
        row.setAttribute("data-rating", s);
        row.setAttribute("aria-label", T.filtered(s, n));
        row.appendChild(el("span", "br-histogram__label", s + " ★"));
        var bar = el("span", "br-histogram__bar");
        var fill = el("span", "br-histogram__fill");
        fill.style.width = (data.count ? Math.round((n / data.count) * 100) : 0) + "%";
        bar.appendChild(fill);
        row.appendChild(bar);
        row.appendChild(el("span", "br-histogram__n", String(n)));
        row.addEventListener("click", function (e) { onFilter(Number(e.currentTarget.getAttribute("data-rating"))); });
        hist.appendChild(row);
      }
      box.appendChild(hist);
    }
    if (opts.showFit && data.fit && data.fit.total) box.appendChild(renderFit(data.fit));
    return box;
  }

  /** 1 … 4 5 [6] 7 8 … 20 */
  function pageNumbers(current, last) {
    var out = [];
    for (var i = 1; i <= last; i++) {
      if (i === 1 || i === last || Math.abs(i - current) <= 1) out.push(i);
      else if (out[out.length - 1] !== "…") out.push("…");
    }
    return out;
  }

  function init(root) {
    if (root.__brReviews) return;
    root.__brReviews = true;
    var dataEl = root.querySelector("script[type='application/json']");
    var summary = null;
    try { summary = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { summary = null; }
    var api = root.getAttribute("data-api");
    var attr = function (name, dflt) { var v = root.getAttribute("data-" + name); return v == null ? dflt : v; };
    var opts = {
      productId: attr("product-id", ""),
      perPage: Number(attr("per-page", 5)) || 5,
      grouped: attr("grouped", "false") === "true",
      groupNote: attr("group-note", "Gjelder alle farger av denne varen"),
      replyLabel: attr("reply-label", T.reply),
      showHistogram: attr("show-histogram", "true") !== "false",
      showColour: attr("show-colour", "true") !== "false",
      showVerified: attr("show-verified", "true") !== "false",
      showFit: attr("show-fit", "true") !== "false",
    };
    var mount = root.querySelector(".br-mount") || root;

    if (!summary || !summary.count) {
      mount.appendChild(el("p", "br-empty", attr("empty-text", T.none)));
      return;
    }

    var state = { rating: null, page: 1, total: summary.count, requestId: 0 };
    var list = el("div", "br-list");
    list.setAttribute("aria-live", "polite");
    var filterBar = el("div", "br-filterbar");
    var pager = el("nav", "br-pager");
    pager.setAttribute("aria-label", "Sider med anmeldelser");
    var status = el("p", "br-status");

    function renderList(reviews) {
      list.innerHTML = "";
      reviews.forEach(function (r) { list.appendChild(renderReview(r, opts)); });
    }

    function renderPager() {
      pager.innerHTML = "";
      var last = Math.max(1, Math.ceil(state.total / opts.perPage));
      if (last <= 1) return;
      function btn(label, page, step, aria) {
        var b = el("button", "br-page" + (step ? " br-page--step" : ""), label);
        b.type = "button";
        if (aria) b.setAttribute("aria-label", aria);
        if (!step && page === state.page) {
          b.setAttribute("aria-current", "page");
          b.classList.add("is-current");
        }
        if (page < 1 || page > last) b.disabled = true;
        else b.addEventListener("click", function () { go(page, true); });
        return b;
      }
      pager.appendChild(btn("‹", state.page - 1, true, T.prev));
      pageNumbers(state.page, last).forEach(function (p) {
        if (p === "…") pager.appendChild(el("span", "br-page__gap", "…"));
        else pager.appendChild(btn(String(p), p, false, T.page(p)));
      });
      pager.appendChild(btn("›", state.page + 1, true, T.next));
    }

    function scrollToTop() {
      // Only when the top of the section is above the viewport (the shopper scrolled down to the pager).
      if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function go(page, fromPager) {
      state.page = page;
      status.textContent = "";
      // Every navigation invalidates responses still in flight, including the embedded path below.
      var id = ++state.requestId;
      root.classList.remove("is-loading");
      var embedded = summary.reviews || [];
      // Page 1 unfiltered renders straight from the metafield when it holds a full page.
      if (page === 1 && !state.rating && embedded.length >= Math.min(opts.perPage, summary.count)) {
        state.total = summary.count;
        renderList(embedded.slice(0, opts.perPage));
        renderPager();
        if (fromPager) scrollToTop();
        return;
      }
      if (api == null) return;
      root.classList.add("is-loading");
      var url = api + "/api/reviews?product_id=" + encodeURIComponent(opts.productId) + "&per_page=" + opts.perPage + "&page=" + page + (state.rating ? "&rating=" + state.rating : "");
      fetch(url)
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (data) {
          if (id !== state.requestId) return;
          state.total = data.total;
          renderList(data.reviews);
          renderPager();
          if (fromPager) scrollToTop();
        })
        .catch(function () { if (id === state.requestId) status.textContent = T.error; })
        .then(function () { if (id === state.requestId) root.classList.remove("is-loading"); });
    }

    function setFilter(rating) {
      state.rating = state.rating === rating ? null : rating;
      Array.prototype.forEach.call(root.querySelectorAll(".br-histogram__row"), function (b) {
        b.classList.toggle("is-active", Number(b.getAttribute("data-rating")) === state.rating);
      });
      filterBar.innerHTML = "";
      if (state.rating) {
        filterBar.appendChild(el("span", null, T.filtered(state.rating, summary.histogram[String(state.rating)] || 0)));
        var clear = el("button", "br-filterbar__clear", T.showAll);
        clear.type = "button";
        clear.addEventListener("click", function () { setFilter(state.rating); });
        filterBar.appendChild(clear);
      }
      go(1, false);
    }

    mount.appendChild(renderSummary(summary, opts, setFilter));
    mount.appendChild(filterBar);
    mount.appendChild(list);
    mount.appendChild(status);
    mount.appendChild(pager);
    go(1, false);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-brando-reviews]"), init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
  window.BrandoReviews = { init: init, stars: stars };
})();
